import { CssVariables, ThemeKeys, black, dark, darkGray, lightGray, themes, white } from "@clinicaltoolkits/universal-react-components";
import { createTheme, mergeThemeOverrides } from "@mantine/core";

export const websiteThemeOverride = createTheme({});

export const cssVariableOverrides: CssVariables = {
  light: {
    "--CT-colors-background": white[0],
    "--CT-colors-paper-background": white[0],
    "--CT-colors-paper-background-secondary": lightGray[0],
    // Likely deprecated
    "--CT-colors-background-root": white[0],
    "--CT-colors-background-main-content": lightGray[0],
  },
  dark: {
    "--CT-colors-background": black[0],
    "--CT-colors-paper-background": dark[7],
    "--CT-colors-paper-background-secondary": dark[7],
    // Likely deprecated
    "--CT-colors-background-root": black[0],
    "--CT-colors-background-main-content": darkGray[9],
  },
};

export const websiteTheme = mergeThemeOverrides(themes[ThemeKeys.Default], websiteThemeOverride);
